// ═══════════════════════════════════════════════════════════════════════════════
// Nested routes under /hfs-admin/*
// ═══════════════════════════════════════════════════════════════════════════════

import { Navigate, Route, Routes } from 'react-router-dom';
import { AdminProtectedRoute } from '../../components/AdminProtectedRoute';
import { adminPortalPath } from '../../lib/adminPortalPaths';
import { NotFoundPage } from '../NotFoundPage';
import { AdminLayout } from './AdminLayout';
import { AdminLoginPage } from './AdminLoginPage';
import { AdminDashboardPage } from './AdminDashboardPage';
import { AdminUsersPage } from './AdminUsersPage';
import { AdminUserDetailPage } from './AdminUserDetailPage';
import { AdminSettingsPage } from './AdminSettingsPage';
import { AdminAuditLogsPage } from './AdminAuditLogsPage';
import { AdminAdminsPage } from './AdminAdminsPage';
import { AdminFaqsPage } from './AdminFaqsPage';
import { AdminLegalDocumentsPage } from './AdminLegalDocumentsPage';
import { AdminInvitationCodesPage } from './AdminInvitationCodesPage';
import { AdminSystemMessagesPage } from './AdminSystemMessagesPage';

export const AdminPortalRoutes = () => (
  <Routes>
    <Route path="login" element={<AdminLoginPage />} />
    <Route element={<AdminProtectedRoute />}>
      <Route element={<AdminLayout />}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboardPage />} />
        <Route path="users" element={<AdminUsersPage />} />
        <Route path="users/:id" element={<AdminUserDetailPage />} />
        <Route path="settings" element={<AdminSettingsPage />} />
        <Route path="invitation-codes" element={<AdminInvitationCodesPage />} />
        <Route path="system-messages" element={<AdminSystemMessagesPage />} />
        <Route path="audit-logs" element={<AdminAuditLogsPage />} />
        <Route path="legal-documents" element={<AdminLegalDocumentsPage />} />
        <Route path="faqs" element={<AdminFaqsPage />} />
        <Route path="admins" element={<AdminAdminsPage />} />
      </Route>
    </Route>
    <Route
      path="*"
      element={
        <NotFoundPage
          homeTo={adminPortalPath('login')}
          title="Page not found"
          body="The admin page you are looking for does not exist or has been removed."
          homeLabel="Go to admin login"
        />
      }
    />
  </Routes>
);
